<template>
    <div class="layui-fluid" style="padding:0">
        <div class="layui-row layui-col-space15">
            <div class="layui-col-md12">
                <div class="layui-card">
                    <!-- <div class="layui-card-header"></div> -->
                    <div class="layui-card-body layui-form">
                        <div class="layui-tab layui-tab-brief">
                            <ul class="layui-tab-title">
                                <li class="layui-this" @click="onDraw('today')">当天访问情况</li>
                                <li  @click="onDraw('year')">按年统计</li>
                                <li  @click="onDraw('month')">按月统计</li>
                                <li  @click="onDraw('day')">按天统计</li>
                                <li  @click="onDraw('os')">按操作系统</li>
                                <li  @click="onDraw('browser')">按浏览器类型</li>
                            </ul>
                            <div class="layui-tab-content" id="analyseContent">
                                <div class="layui-tab-item layui-show" id="today"></div>
                                <div class="layui-tab-item" id="year"></div>
                                <div class="layui-tab-item">
                                    <div class="layui-inline"><label class="layui-search-label">年度</label></div>
                                    <div class="layui-inline">
                                        <layui-year v-model="yearForDrawMonth" @change="handleYearForDrawMonth($event)"></layui-year>
                                    </div>
                                    <div id="month" style="height:calc(100% - 38px);margin-top:20px"></div>
                                </div>
                                <div class="layui-tab-item" >
                                    <div class="layui-inline"><label class="layui-search-label">年月</label></div>
                                    <div class="layui-inline">
                                        <layui-yearmonth v-model="yearMonthForDrawDay" @change="handleYearMonthForDrawDay($event)"></layui-yearmonth>
                                    </div>
                                    <div id="day" style="height:calc(100% - 38px);margin-top:20px"></div>
                                </div>
                                <div class="layui-tab-item">
                                      <div class="layui-inline"><label class="layui-search-label">时间</label></div>
                                        <div class="layui-inline">
                                            <layui-datetimerange v-model="rangeforOs" style="width:350px"></layui-datetimerange>
                                      </div>
                                       <div class="layui-inline" style="margin-left:20px">
                                            <button class="layui-btn" title="查询" @click="drawOs()">查询</button>
                                            <button class="layui-btn" title="重置" @click="rangeforOs = '';drawOs()">重置</button>
                                        </div>
                                        <div id="os" style="height:calc(100% - 38px);margin-top:20px"></div>
                                </div>
                                <div class="layui-tab-item">
                                       <div class="layui-inline"><label class="layui-search-label">时间</label></div>
                                       <div class="layui-inline">
                                            <layui-datetimerange v-model="rangeforBrowser" style="width:350px"></layui-datetimerange>
                                       </div>
                                       <div class="layui-inline" style="margin-left:20px">
                                            <button class="layui-btn" title="查询" @click="drawBrowser()">查询</button>
                                            <button class="layui-btn" title="重置" @click="rangeforBrowser = '';drawBrowser()">重置</button>
                                        </div>
                                        <div id="browser" style="height:calc(100% - 38px);margin-top:20px"></div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts';
import request from '../../../network/networkconfig'
export default {
    name: 'LogAnalyse',
    data () {
        return {
            drawMap: {},// 避免数据污染
            yearForDrawMonth: null, //按照月份统计时，选择的年份
            yearMonthForDrawDay: null, //按照天统计时，选择的年月
            rangeforOs: null, //按照操作系统统计时，选择的区间
            rangeforBrowser: null, //按照浏览器类型统计时，选择的区间
        }
    },
    mounted() {
        $("#analyseContent").find(".layui-tab-item").css("height", $(window).height() - 198);
        this.onDraw('today');
        let date = new Date();
        let curYear = date.getFullYear();
        let curMonth = date.getMonth() + 1;
        curMonth = curMonth > 10 ? curMonth : '0' + curMonth;
        this.yearForDrawMonth = curYear;
        this.yearMonthForDrawDay = curYear + '-' + curMonth;
    },

    methods: {
        onDraw(drawType) {
            if(!this.drawMap[drawType]) {
                this.drawMap[drawType] = 'loaded';
                switch (drawType) {
                    case 'today': this.drawToday();return;
                    case 'year' : this.drawYear();return;
                    case 'month': this.drawMonth();return;
                    case 'day'  : this.drawDay(); return;
                    case 'os'   : this.drawOs(); return;
                    case 'browser'  : this.drawBrowser(); return;
                }
            }
        },
        drawToday() {
            //当天统计
            request({
                url: '/data/log/analyse/today/log-today',
                method: 'post',
                data : {}
            }).then((result) => {
                let myChart = echarts.init(document.getElementById('today'));
                // { 01: '', 02: '' ....}
                var map = result.result;
                var xdata = [];
                var sdata = [];
                for(var i = 0 ; i < 24; i++) {
                    var targetKey = (i >= 10 ? ('' + i) : ('0' + i));
                    if(!map[targetKey]) {
                        map[targetKey] = 0;
                    }
                    var h =  Number(targetKey);
                    xdata.push(h + "~" + (h + 1) +"点");
                    sdata.push(map[targetKey]);
                }
                var type = "当天访问情况"
                var option = this.getOption(xdata, sdata,type);
                myChart.setOption(option);
            });

        },
        drawYear() {
            //按年统计 没有输入框
            // {2018,2019,2020,2021,2022,2023}
            request({
                url: '/data/log/analyse/year/log-year',
                method:'post',
                data:{}
            }).then((result) => {
                let myChart = echarts.init(document.getElementById('year'));
                 // { 2018: '', 2019: '' ....}
                 var map  = result.result;
                 var xdata = [];
                 var sdata = [];
                 for (var key in map ){
                     xdata.push(key + '年')
                     var targetKey = key + '年'
                     sdata.push(map[key])
                 }
                var type = "按年统计情况"
                var option = this.getOption(xdata, sdata,type);
                myChart.setOption(option);
            })
        },
        handleYearForDrawMonth(year){
            this.drawMonth();
        },
        drawMonth() {
             request({
                url: '/data/log/analyse/month/log-month',
                method:'post',
                params: {
                     years: this.yearForDrawMonth,
                }
            }).then((result) => {
                let myChart = echarts.init(document.getElementById('month'));
                 // { 2018: '', 2019: '' ....}
                 var map  = result.result;
                 var newMap = {};
                 for (var key in map){
                     if (key.startsWith('0')){
                         var newKey  = key[1];
                         newMap[newKey] = map[key]
                     }else{
                         newMap[key] = map[key]
                     }
                 }
                 var xdata = [];
                 var sdata = [];
                  for(var i = 1 ; i < 13; i++) {
                    var targetKey  = i;
                    if(!newMap[targetKey]) {
                        newMap[targetKey] = 0;
                    }
                    xdata.push(targetKey +"月");
                    sdata.push(newMap[targetKey]);
                  }
                var type = "按月统计情况"
                var option = this.getOption(xdata, sdata,type);
                myChart.setOption(option);
            })
        },
        handleYearMonthForDrawDay(yearMonth){
           this.drawDay();
        },
        drawDay() {
            let arr = this.yearMonthForDrawDay.split('-');
            request({
                url: '/data/log/analyse/day/log-day',
                method: 'post',
                params: {
                     year: arr[0],
                     month: arr[1],
                }
            }).then((result) => {
                let myChart = echarts.init(document.getElementById('day'));
                var map = result.result;
                var xdata = [];
                var sdata = [];
                var keyArr = [];
                let days = new Date(arr[0], arr[1], 0).getDate();
                for (var i = 1 ; i <= days; i++ ){
                    let key = i < 10 ? '0' + i : i;
                    keyArr.push(key)
                 }
                 for (var i = 0; i <keyArr.length; i++ ){
                     xdata.push(keyArr[i] +'号')
                     let v = map[keyArr[i]];
                     v = v ? v : 0;
                     sdata.push(v)
                 }
                var type = "按天访问情况"
                var option = this.getOption(xdata, sdata,type);
                myChart.setOption(option);
            });
        },
        drawOs() {
            let begin = null;
            let end = null;
            if(this.rangeforOs){
                let arr = this.rangeforOs.split(' - ');
                begin = arr[0];
                end = arr[1];
            }
            request({
                url: '/data/log/analyse/os/log-os',
                method: 'post',
                params: {
                     begin: begin,
                     end: end,
                }
            }).then((result) => {
                let myChart = echarts.init(document.getElementById('os'));
                var map = result.result;
                var pieData = [];
                var legendData = [];
                var title = "操作系统";
                for(var p in map) {
                    var obj = {};
                    obj.name = p;
                    obj.value = map[p];
                    pieData.push(obj);
                    legendData.push(p);
                }
                var option = this.getPieOption(title, legendData, pieData);
                myChart.setOption(option);
            });
        },
        drawBrowser() {
            let begin = null;
            let end = null;
            if(this.rangeforBrowser){
                let arr = this.rangeforBrowser.split(' - ');
                begin = arr[0];
                end = arr[1];
            }
            request({
                url: '/data/log/analyse/browser/log-browser',
                method: 'post',
                params: {
                     begin: begin,
                     end: end,
                }
            }).then((result) => {
                let myChart = echarts.init(document.getElementById('browser'));
                var map = result.result;
                var pieData = [];
                var legendData = [];
                var title = "浏览器";
                for(var p in map) {
                    var obj = {};
                    obj.name = p;
                    obj.value = map[p];
                    pieData.push(obj);
                    legendData.push(p);
                }
                var option = this.getPieOption(title, legendData, pieData);
                myChart.setOption(option);
            });
        },
        getOption(xdata, sdata,type) {
            return {
                title:{
                show:true,
                text:type,
                },
                tooltip:{
                show:true,
                trigger:'axis',
                formatter:function(params){
                    var relVal =params[0].name + " 访问：";
                    relVal +=params[0].value +"次";
                    return relVal;
                },

                showDelay:0,
                hideDelay:50,
                transitionDuration:0,
                backgroundColor:'rgba(50,50,50,1)',
                borderColor:'#aaa',
                showContent: true,
                borderRadius:8,
                padding:10
                },
                axisPointer:{
                type:'line',
                axis:'auto'
                },
                legend:{
                data:['']
                },
                xAxis:{
                data: xdata,
                    axisLabel: {
                        interval: 0,
                        rotate: 30
                    },
                },
                yAxis:{},
                series:[{
                type:'bar',
                barMaxWidth:60,
                data : sdata,
                    label: {
                        normal: {
                            position: 'top',
                            show: true
                        }
                    },

                itemStyle:{
                    normal:{
                    color:new echarts.graphic.LinearGradient(0,0,0.5,1,[{
                        offset:0,
                        color:'rgba(35,123,105,1)'
                    },{
                        offset:1,
                        color:'rgba(103,237,210,.5)'
                    }]),
                    borderColor:'#23a5e2',
                    borderWidth:2,
                    barBorderRadius:[10,10,0,0],
                    shadowColor:'rgba(168,225,226,0.5)',
                    opacity:.6

                    },
                    emphasis:{
                    color:new echarts.graphic.LinearGradient(0,0,0,1,[{
                        offset:0,
                        color:'rgba(13,164,171,1)'
                    },{
                        offset:1,
                        color:'rgba(64,180,157,.1)'
                    }]),
                    borderColor:'#0ea4a6',
                    borderWidth:2,
                    barBorderRadius:[9,9,0,0],
                    shadowBlur:30,
                    shadowColor:'rgba(32,188 ,157,0.8)',
                    opacity:.7,
                    label:{
                        show:true,
                        textStyle:{
                        color:'rgba(150,197,188,1)'
                        }

                    }
                    }
                },
                markPoint:{
                    symbol: 'circle',
                    symbolSize:50,
                    symbolOffset: [0,0],
                    silent:true

                }

                }],
                label:{
                normal:{
                    show:true,
                    position:'top'

                }
                }

		   };
        },

        getPieOption(title, legendData, pieData){
            var img = 'data:image/png;base64,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';
            var data = [];
            var color=['#00ffff','#00cfff','#006ced','#ffe000','#ffa800','#ff5b00','#ff3000']
            for (var i = 0; i < pieData.length; i++) {
                data.push({
                    value: pieData[i].value,
                    name: pieData[i].name,
                    itemStyle: {
                        normal: {
                            borderWidth: 5,
                            shadowBlur: 20,
                            borderColor:color[i],
                            shadowColor: color[i]
                        }
                    }
                }, {
                    value: 2,
                    name: '',
                    itemStyle: {
                        normal: {
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            },
                            color: 'rgba(0, 0, 0, 0)',
                            borderColor: 'rgba(0, 0, 0, 0)',
                            borderWidth: 0
                        }
            }
                });
            }
            var seriesOption = [{
                name: '',
                type: 'pie',
                clockWise: false,
                radius: [105, 109],
                hoverAnimation: false,
                itemStyle: {
                    normal: {
                        label: {
                            show: true,
                            position: 'outside',
                            color: '#000',
                            formatter: function(params) {
                                var percent = 0;
                                var total = 0;
                                for (var i = 0; i < pieData.length; i++) {
                                    total += Number(pieData[i].value);
                                }
                                percent = ((params.value / total) * 100).toFixed(0);
                                if(params.name !== '') {
                                    return title + '：' + params.name + '\n' + '\n' + '占百分比：' + percent + '%';
                                }else {
                                    return '';
                                }
                            },
                        },
                        labelLine: {
                            length:30,
                            length2:100,
                            show: true,
                            color:'#00ffff'
                        }
                    }
                },
                data: data
            }];
         return  {
                color : color,
                title: {
                    text: title,
                    top: '48%',
                    textAlign: "center",
                    left: "49%",
                    textStyle: {
                        color: '#000',
                        fontSize: 22,
                        fontWeight: '400'
                    }
                },
                graphic: {
                elements: [{
                    type: "image",
                    z: 3,
                    style: {
                        image: img,
                        width: 178,
                        height: 178
                    },
                    left: 'center',
                    top:  'center',
                    position: [100, 100]
                }]
                },
                tooltip: {
                    show: false
                },
                legend: {
                    icon: "circle",
                    orient: 'horizontal',
                    // x: 'left',
                    data: legendData,
                    right: '5%',
                    bottom: '5%',
                    align: 'right',
                    textStyle: {
                    color: "#000"
                    },
                    itemGap: 20
                },
                toolbox: {
                    show: false
                },
                series: seriesOption
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ywpt/log/logAnalyse.vue